import React from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import { withStyles } from '@material-ui/core/styles';
var styles = {
  snackbar: {
    width: '100%',
    pointerEvents: 'none',
    '& > div': {
      height: 65,
      minWidth: '30%',
      boxShadow: 'none !important',
      borderRadius: 0,
      fontSize: 16,
      '& > div': {
        width: '100%',
        textAlign: 'center'
      }
    }
  },
  success: {
    '& div': {
      backgroundColor: 'green'
    }
  },
  error: {
    '& div': {
      backgroundColor: 'red'
    }
  }
};

var DefiSnackbar = function DefiSnackbar(props) {
  var _onClose = props.onClose,
      classes = props.classes,
      color = props.color,
      open = props.open,
      children = props.children;
  var background = color === 'green' ? "".concat(classes.snackbar, " ").concat(classes.success) : "".concat(classes.snackbar, " ").concat(classes.error);
  return React.createElement(Snackbar, {
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center'
    },
    id: "snackbar",
    className: background,
    open: open,
    autoHideDuration: 5000,
    onClose: function onClose() {
      return _onClose({
        open: false,
        color: color,
        message: ''
      });
    },
    ContentProps: {
      'aria-describedby': 'message-id'
    },
    message: React.createElement("div", {
      id: "message-id"
    }, children),
    action: [],
    "data-testid": "DefiSnackbar"
  });
};

export default withStyles(styles)(DefiSnackbar);